import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Bell, Lock } from 'lucide-react'
import { api } from '@/lib/api'

/** OPT-040：预约前自动提醒配置（L1 专有，提前时长 24/12/6h 单选） */
export function ReminderSettingsCard() {
  const { t } = useTranslation()
  const qc = useQueryClient()

  const { data: me } = useQuery({ queryKey: ['me'], queryFn: () => api.me() })
  const { data: current } = useQuery({ queryKey: ['subscription', 'current'], queryFn: () => api.getSubscriptionCurrent() })
  const isPro = current?.tier === 'starter'
  const lead = me?.reminderLeadHours ?? 24

  const update = useMutation({
    mutationFn: (hours: number) => api.updateMe({ reminderLeadHours: hours }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['me'] })
    },
  })

  return (
    <Card data-testid="reminder-settings-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Bell className="h-4 w-4" /> {t('settings.reminder.title')}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <p className="text-sm text-slate-600">{t('settings.reminder.description')}</p>
        {!isPro ? (
          <p className="text-sm text-slate-400 flex items-center gap-1.5">
            <Lock className="h-3.5 w-3.5" /> {t('settings.reminder.locked')}
          </p>
        ) : (
          <div className="flex gap-2">
            {[24, 12, 6].map((h) => (
              <Button
                key={h}
                data-testid={`reminder-lead-${h}`}
                variant={lead === h ? 'default' : 'outline'}
                size="sm"
                disabled={update.isPending && update.variables === h}
                onClick={() => update.mutate(h)}
              >
                {h}h
              </Button>
            ))}
          </div>
        )}
        {update.isError && <p className="text-sm text-red-600">{t('common.failed')}</p>}
      </CardContent>
    </Card>
  )
}
